import { useTranslation } from 'react-i18next';
import Button from '../../../../../../common/widgets/Button';
import Dialog from '../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';
import Input from '../../../../../../common/widgets/Input';
import { useState } from 'react';

interface ApplyCashbackDialogProps {
  closeDialog: () => void;
  applyCashback: (value: number) => void;
  cashbackAmount: number;
  maxCashbackAmount: number;
  cashbackBudget: number;
  productPrice: number;
}

export const ApplyCashbackDialog = (props: ApplyCashbackDialogProps) => {
  const {
    closeDialog,
    applyCashback,
    cashbackAmount,
    maxCashbackAmount,
    cashbackBudget,
    productPrice,
  } = props;

  const minValue = 0.1;
  const realProductPrice = productPrice + cashbackAmount;
  const [cashbackValue, setCashbackValue] = useState<string>(
    String(cashbackAmount > 0 ? cashbackAmount : maxCashbackAmount),
  );
  const numericCashbackValue = cashbackValue.trim()
    ? Number(cashbackValue)
    : Number.NaN;
  const { t: translate } = useTranslation();
  const [showInvalidCashbackMsg, setShowInvalidCashbackMsg] =
    useState<boolean>(false);
  return (
    <Dialog closeDialog={closeDialog} showCloseIcon className="cashback-dialog">
      <div className="dialog-content">
        <div className="dialog-text centered">
          <Icons.ApplyCashback />
        </div>
        <div className="dialog-title">
          <h2>{translate(resources.products.applyCashback.title)}</h2>
        </div>
        <div className="dialog-text centered">
          <p>
            <span className="apply-cashback-budget">
              {translate(resources.products.applyCashback.budgetInfo10, {
                0: cashbackBudget,
              })}
            </span>
            <span>
              <b>
                {' '}
                {' ' + translate(resources.products.applyCashback.budgetInfo11)}
              </b>
            </span>
            <br />
            <span>
              {translate(resources.products.applyCashback.budgetInfo2)}
            </span>
          </p>
        </div>
        <div className="input-currency-wrapper">
          <Input
            type="number"
            value={cashbackValue}
            min={minValue}
            step="any"
            max={cashbackBudget}
            onChange={e => setCashbackValue(String(e.target.value ?? ''))}
            className="currency-input"
            controlClassName="no-bottom-margin"
          />
          <span className="currency-symbol">RON</span>
        </div>

        {!showInvalidCashbackMsg && (
          <span className="cashback-dialog-note">
            {translate(resources.products.applyCashback.budgetInfo3, {
              0: cashbackBudget,
            })}
          </span>
        )}
        {showInvalidCashbackMsg && (
          <span className="cashback-dialog-error">
            {realProductPrice < numericCashbackValue
              ? translate(
                  resources.products.applyCashback.invalidCashback.price,
                  {
                    0: realProductPrice,
                  },
                )
              : translate(
                  resources.products.applyCashback.invalidCashback.maxValue,
                  {
                    0: cashbackBudget,
                  },
                )}
          </span>
        )}
      </div>
      <div className="dialog-actions horizontal">
        <Button onClick={closeDialog} className="btn btn-outline">
          {translate(resources.cancel)}
        </Button>

        <Button
          onClick={() => {
            setShowInvalidCashbackMsg(false);
            if (
              !Number.isFinite(numericCashbackValue) ||
              (numericCashbackValue !== 0 && numericCashbackValue < minValue)
            ) {
              return;
            }

            const isInvalid =
              numericCashbackValue > cashbackBudget ||
              numericCashbackValue > realProductPrice;

            setShowInvalidCashbackMsg(isInvalid);
            if (!isInvalid) {
              applyCashback(numericCashbackValue || 0);
              closeDialog();
            }
          }}
          className="btn btn-solid"
        >
          {translate(resources.products.applyCashback.apply)}
        </Button>
      </div>
    </Dialog>
  );
};
